import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function ProtectedRoute({ children, role, allowOnboarding = false }) {
  const { user, checked } = useAuth();
  const loc = useLocation();

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="w-10 h-10 border-2 border-[#FF3B30] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: loc }} />;
  }
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/employee"} replace />;
  }
  // Employees who haven't completed onboarding get redirected to onboarding except when they're on the onboarding page
  if (user.role === "employee" && user.status === "onboarding" && !allowOnboarding && !loc.pathname.startsWith("/employee/onboarding")) {
    return <Navigate to="/employee/onboarding" replace />;
  }
  return children;
}
